import { Box, FluidImage, SelectionSetTileImageContainer } from '@vp/swan'
import { useState } from 'react'
import type { ReactNode } from 'react'
import type { UnifiedProject, WorkEntity } from '@shared/types/work-entity.types'
import { useWorkEntityImage } from '@shared/hooks/use-work-entity-image'
import { useStyles } from '@vp/ubik-context'
import { stylesheet } from './project-image.scss'

interface ProjectImageProps {
  project: UnifiedProject
}

const ProjectPreviewFrame = ({ children }: { children: ReactNode }) => {
  useStyles(stylesheet)
  return <Box className="project-preview-frame">{children}</Box>
}

const BlankProjectImage = () => (
  <SelectionSetTileImageContainer>
    <ProjectPreviewFrame>
      <Box className="project-preview-frame__blank" />
    </ProjectPreviewFrame>
  </SelectionSetTileImageContainer>
)

const WesProjectImage = ({ workEntity, alt }: { workEntity: WorkEntity; alt?: string }) => {
  const { src, srcSet } = useWorkEntityImage(workEntity)
  const [hasError, setHasError] = useState(false)

  if (!src || hasError) return <BlankProjectImage />

  return (
    <SelectionSetTileImageContainer>
      <ProjectPreviewFrame>
        <FluidImage src={src} srcSet={srcSet} alt={alt} onError={() => setHasError(true)} className="project-preview-frame__image" />
      </ProjectPreviewFrame>
    </SelectionSetTileImageContainer>
  )
}

const AlbelliProjectImage = ({ previewUrl, alt }: { previewUrl?: string; alt?: string }) => {
  const [hasError, setHasError] = useState(false)

  if (!previewUrl || hasError) return <BlankProjectImage />

  return (
    <SelectionSetTileImageContainer>
      <ProjectPreviewFrame>
        <FluidImage src={previewUrl} alt={alt} onError={() => setHasError(true)} className="project-preview-frame__image" />
      </ProjectPreviewFrame>
    </SelectionSetTileImageContainer>
  )
}

export const ProjectImage = ({ project }: ProjectImageProps) => {
  if (project.source === 'albelli') {
    return <AlbelliProjectImage previewUrl={project.previewUrl} alt={project.name} />
  }

  return <WesProjectImage workEntity={project.raw as WorkEntity} alt={project.name} />
}
